import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authStorage, StoredAuth } from '@/services/auth.storage';
import { Admin } from '@/types';

type AuthState = {
  accessToken: string | null;
  admin: Admin | null;
  isAuthenticated: boolean;
};

const stored = authStorage.get();

const initialState: AuthState = {
  accessToken: stored?.accessToken ?? null,
  admin: stored?.admin ?? null,
  isAuthenticated: !!stored?.accessToken,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth(state, action: PayloadAction<StoredAuth>) {
      state.accessToken = action.payload.accessToken;
      state.admin = action.payload.admin;
      state.isAuthenticated = true;
      authStorage.set(action.payload);
    },

    logout(state) {
      state.accessToken = null;
      state.admin = null;
      state.isAuthenticated = false;
      authStorage.clear();
    },
  },
});

export const { setAuth, logout } = authSlice.actions;
export default authSlice.reducer;
